angular.module('impactx.company').controller('CompanyListCtrl', [
    '$scope',
    'CompanyService',
    'selectedListItems',
    'PartialDialogsService',
    '$mdDialog',
    CompanyListCtrl]);

function CompanyListCtrl($scope, CompanyService, selectedListItems, PartialDialogsService, $mdDialog) {
    var self = this;

    PartialDialogsService.setCurrentList(PartialDialogsService.TYPE.COMPANY,"companylist");

    self.deleteCompany = function() {
        CompanyService.deleteCompany(selectedListItems.getFirstSelectedItem(), true, $scope, false, '/company/delete', 'companyListCtrl');
    };

    CompanyService.setCompanyListActions(self, selectedListItems);

    this.canEditTheme = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canEditThemeConfig
                && selectedListItems.getFirstSelectedItem().canEditThemeConfig.value;
    };

    this.canEditDashboard = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().isClientCompany
                && selectedListItems.getFirstSelectedItem().isClientCompany.value;
    };

    this.getEditThemeLink = function() {
        return "themeconfigurator/" + selectedListItems.getFirstSelectedId();
    };

    this.getEditDashboardLink = function() {
        return "editdashboard/" + selectedListItems.getFirstSelectedId();
    };

    this.getEditCompanyGreetingCardLayout = function() {
        return "companygreetingcardlayout/" + selectedListItems.getFirstSelectedId();
    };

    this.canEditCompanyGreetingCardLayout = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().greetingCardAvailable
            && selectedListItems.getFirstSelectedItem().greetingCardAvailable.value;
    };

    this.showEditLogoDialog = function () {
        return $mdDialog.show({
            templateUrl: 'modules/company/templates/company-logo.tmpl.html',
            locals: {comId: selectedListItems.getFirstSelectedId()},
            controller: 'CompanyLogoCtrl',
            controllerAs: 'companyLogoCtrl',
            parent: angular.element(document.body),
            targetEvent: event,
            bindToController: true,
            clickOutsideToClose: false,
        });
    };

    var buttonDefinition = [
        {
            label: "companyData",
            linkFunction: self.getCompanyDataLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCompany'
        },
        {
            label: "clientCompanyData",
            linkFunction: self.getClientCompanyDataLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCompany'
        },
        {
            label: "relations",
            linkFunction: self.getCompanyRelationDataLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCompany'
        },
        {
            label: "interface",
            linkFunction: self.getCompanyInterfaceDataLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCompany'
        },
        {
            label: "themeConfigurator",
            linkFunction: self.getEditThemeLink,
            type: 'link',
            condition: self.canEditTheme,
            process: 'ThemeConfiguratorCompany'
        },
        {
            label: "logo",
            action: self.showEditLogoDialog,
            type: 'dialogaction',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCompany'
        },
        {
            label: "editDashboard",
            linkFunction: self.getEditDashboardLink,
            type: 'link',
            condition: self.canEditDashboard,
            process: 'EditDashboard'
        },
        {
            label: "delete",
            action: self.deleteCompany,
            condition: self.canDelete,
            process: 'EditCompany'
        },
        {
            label: "editCompanyGreetingCardLayout",
            linkFunction: self.getEditCompanyGreetingCardLayout,
            type: 'link',
            condition: self.canEditCompanyGreetingCardLayout,
            process: 'CompanyGreetingCardAdministration'
        }
    ];


    this.meta = {
        rowTemplate: 'modules/company/templates/companylist.row.tmpl.html',
        mainAction: {id: "new", link: "#/companydata/0", icon: "mdi-plus"},
        isSelectAble: true,
        ctrl: this,
        endpoint: '/company/list',
        id: "companylist",
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function() {
        return this.meta;
    };
}